import { render, staticRenderFns } from "./current_comment.vue?vue&type=template&id=d3c3639c&scoped=true&"
import script from "./current_comment.vue?vue&type=script&lang=js&"
export * from "./current_comment.vue?vue&type=script&lang=js&"
import style0 from "./current_comment.vue?vue&type=style&index=0&id=d3c3639c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c3639c",
  null
  
)

export default component.exports